import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogBody,
  DialogFooter,
} from '../../../../components/ui/Dialog';
import { Button } from '../../../../components/ui/Button';

import { usePhaseService } from '../../phaseService';
import PhaseForm from '../forms/PhaseForm';

const PhaseModal = ({ visible, onClose, submitForm, formProps, title }) => {
  const [submit, setSubmit] = useState(false);
  const [phasesTypes, setPhasesTypes] = useState(null);
  const [models, setModels] = useState(null);
  const { getModels, getPhaseTypes } = usePhaseService();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await Promise.all([getPhaseTypes(), getModels()]);
        setPhasesTypes(result[0].data);
        setModels(result[1].data);
      } catch (e) {
        console.log(e);
      }
    };

    fetchData();
  }, []);

  const formSubmit = (id, values) => {
    setSubmit(false);
    submitForm(id, values);
  };

  return (
    <Dialog open={visible} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <PhaseForm
            types={phasesTypes}
            models={models}
            formProps={formProps}
            submit={formSubmit}
            submitOutside={submit}
          />
        </DialogBody>
        <DialogFooter>
          <Button
            key={1}
            variant="outline"
            data-testid="phase-modal-close-btn"
            onClick={() => onClose()}
          >
            Zavřít
          </Button>
          <Button key={2} data-testid="phase-modal-confirm-btn" onClick={() => setSubmit(true)}>
            Potvrdit
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default PhaseModal;
